<template>
  <div class="department-item">
    <div :class="{ 'department-name': true, clamp: true }">
      <span v-if="showMine" class="department-name-mine">{{ $t('common.key92', { cm: '我的' }) }}</span>
      {{ value.name }}
    </div>
    <div :class="{ 'department-code': true, clamp: true }">
      {{ value.custDeptNumber }}
    </div>
  </div>
</template>

<script type="text/ecmascript-6">

/**
 * 部门列表的item部分Ui
 */
export default {
  name:'department-item',
  props:{
    value:{
      type:Object,
    },
    userInfo:{
      type:Object,
    }
  },
  data() {
    return {
    };
  },
  computed:{
    showMine(){
      return this.userInfo?.departmentOID === this.value.departmentOID;
    }
  }

};
</script>

<style lang="scss" scoped>
.department-item {
  height: 100%;
  .department-name {
    word-break: break-word;
    color: #252629;
    font-weight: 400;
    font-size: px(28);
    &.clamp {
      @include text-line(3);
    }
    &-mine {
      //box-sizing: border-box;
      background: #dde2e5;
      color: #495c6d;
      padding: px(2) px(8);
      line-height: px(32);
      font-weight: 400;
      border-radius: px(2);
      font-size: px(20);
    }
  }
  .department-code {
    color: #71757e;
    font-weight: 400;
    font-size: px(24);
  }
}
</style>
